export default __webpack_public_path__ + "static/media/codeigniter.dbdcceab.png";